<template lang="pug">
validation-observer.analise(ref='validation' tag='div')
  div.analise(v-if="despacho !== null")
    app-analise-header(
      :id-processo="despacho.processo.id",
      v-if="despacho.processo !== null"
      :numero-processo="despacho.processo.numeroProcesso",
      :statusProcesso="despacho.processo.status"
      titulo-analise="Emissão do extrato de sentença"
      :tipo="typeof despacho.processo.tipo === 'object' ? despacho.processo.tipo.codigo : despacho.processo.tipo",
      :numeroProtocolo="despacho.processo.numeroProtocolo",
      :show-separate="true"
      :show-messages='true',
      :opcoesHeader="true",
      :btnSolicitarInformacao="true",
      :idDespacho="despacho.id",
    )
      template(slot="separate")
        el-card(shadow="hover").card-collapse
          app-despachos(
            :idProcesso="idProcesso",
            :data="dadosCadastro",
            @getDownload="getDownload",
          )
      template(slot="analise")
        el-steps.extra-margin-top-bottom(:active='active', finish-status='success', simple)
          el-step(title='Informar dados')
          el-step(title='Confirmar dados')
        div(v-if="active === 0")
          app-emissao-extrato-sentenca(
            :despacho="despacho",
            ref='formulario'
            v-if="despacho"
          )
        div(v-else-if="active === 1")
          app-pdf-viewer(
            v-if="bytes"
            :bytes = "bytes"
          )
          validation-observer.flex-around(ref='validationTitulo' tag='div')
            app-radios-tramitacao(
              :radios="acoesRadio",
              :isDecisao="false",
              @changeRadio="changeRadio",
              :radioInicial="despacho.acao",
            )
        app-buttons-cadastro(
          :isPrimeiroPasso="active === 0",
          :isUltimoPasso="active === 1",
          :showButtonSalvar="[0].includes(active)",
          :showButtonDownload="[1].includes(active)",
          :showButtonCancelar="[0].includes(active)",
          :showButtonFinalizar="[1].includes(active)"
          :showButtonProximo="[0].includes(active)"
          @proximo="proximo",
          @salvar="salvarExtratoSentenca",
          @voltar="voltar",
          @finalizar="finalizar",
          @download="downloadPdf",
          @cancelar="cancelar"
        )
</template>

<script>
import axios from '@/utils/api'
import FileSaver from 'file-saver'
import AppAnaliseHeader from './components/shared/AppAnaliseHeader'
import acaoProcesso from '@/constants/acaoProcesso'
import AppPdfViewer from '@/components/AppPDFViewer'
import AppEmissaoExtratoSentenca from '@/screens/analise/components/AppEmissaoExtratoSentenca'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import FileHelper from '@/utils/fileHelper'
import AppDespachos from '@/components/AppDespachos'
import AppRadiosTramitacao from '@/components/AppRadiosTramitacao'
import AppLabel from '@/components/AppLabel'
import AppButtonsCadastro from '@/components/AppButtonsCadastro.vue'
import { mapActions } from 'vuex'
const { messages } = require('@/utils/' +
  process.env.ESTADO +
  '/regrasAnalise').default

export default {
  props: {
    idProcesso: {
      type: [Number, String]
    },
    tipo: {
      type: String,
      default: acaoProcesso.EMITIR_EXTRATO_SENTENCA
    },
    urlOrigem: {
      type: String,
      default: 'CAIXA_ENTRADA'
    }
  },

  mixins: [AppNotificacao],

  components: {
    AppAnaliseHeader,
    AppPdfViewer,
    AppDespachos,
    AppRadiosTramitacao,
    AppLabel,
    AppButtonsCadastro,
    AppEmissaoExtratoSentenca
  },

  data () {
    return {
      active: 0,
      bytes: null,
      despacho: null,
      dadosCadastro: null,
      acoesRadio: [],
      processo: null
    }
  },

  async mounted () {
    await this.iniciaEmissao()
  },

  methods: {
    ...mapActions({
      iniciaAnalise: 'processo/iniciaAnalise',
      salvar: 'despacho/salvar',
      finalizarDespacho: 'despacho/finalizar',
      tarefa: 'processo/tarefa',
      getArrayExtratoSentenca: 'despacho/getArrayExtratoSentencaByDespachoId'
    }),

    async salvarExtratoSentenca () {
      var despacho = this.$refs.formulario.salvarDespacho()
      try {
        await this.salvar(despacho)
        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          `${messages.headerExtratoSentenca} salvo com Sucesso.`)
      } catch (e) {}
    },

    cancelar () {
      this.confirmBox(
        `Ao cancelar a Emissão do Extrato de Sentença, ${this.$messages.CANCELAR_EMISSAO_TITULO_CERTIDAO}`,
        this.$messages.TITULO_WARNING,
        () => {
          this.$router.back()
        },
        () => {}
      )
    },

    getMensagemEncaminhamento () {
      switch (this.despacho.acao) {
        case 'FINALIZAR.NUTIT':
          return 'Processo enviado para assinatura GAB'
        case 'ARQUIVAMENTO.SISTEMA.NUTIT.AUTOCOMPLETE':
          return 'Processo enviado para arquivamento GAB'
        default:
          return ''
      }
    },

    async finalizar () {
      if (this.despacho.acao) {
        this.confirmBox(
          this.$messages.MSG_CONFIRMACAO,
          this.$messages.TITULO_WARNING,
          () => {
            this.finalizarDespacho(this.despacho)
              .then(() => {
                this.showNotificacao(
                  this.$messages.TIPO_SUCCESS,
                  this.$messages.TITULO_SUCCESS,
                  this.getMensagemEncaminhamento()
                )
                this.$router.push({
                  name: this.urlOrigem
                })
              })
              .catch(error => {
                const erroValidacao = error.status === 422
                const tipoErro = !erroValidacao
                  ? this.$messages.TIPO_ERROR
                  : this.$messages.TIPO_WARNING
                const tituloErro = !erroValidacao
                  ? this.$messages.TITULO_ERROR
                  : this.$messages.TITULO_WARNING
                const messagemDeErro =
                  Array.isArray(error.erros) && erroValidacao
                    ? error.erros.join(';')
                    : 'Erro ao emitir/conferir extrato de sentença.'
                this.showNotificacao(tipoErro, tituloErro, messagemDeErro)
              })
          },
          () => {}
        )
      } else {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          'Selecione para onde deseja encaminhar o processo.'
        )
      }
    },

    async iniciaEmissao () {
      const response = await this.iniciaAnalise({
        idProcesso: this.idProcesso,
        tipoAcao: this.tipo
      })
      this.setDespachoVazio(response)
      this.dadosCadastro = response.setores
      const radios = await this.tarefa({ processo: this.idProcesso })
      this.acoesRadio = radios.acoes
    },

    async proximo () {
      this.despacho = this.active === 0 ? this.$refs.formulario.save() : this.despacho
      if (this.despacho) {
        const despachoSalvo = await this.salvar(this.despacho)

        const arraybufferExtratoSentenca = await this.getArrayExtratoSentenca(despachoSalvo.id)
        this.despacho.id = despachoSalvo.id
        this.bytes = arraybufferExtratoSentenca
        this.active++
      } else {
        // Fazer aqui algum tipo de retorno para caso dê errado as validações
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          'Para finalizar a análise preencha todos os campos destacados.'
        )
      }
    },
    async voltar () {
      await this.iniciaEmissao()
      this.active = 0
    },

    downloadPdf () {
      FileHelper.saveFile(
        this.bytes,
        this.despacho.processo.tipo.codigo === 'minuta do extrato de sentença'
      )
    },

    async getDownload (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.nome)
    },

    changeRadio (value) {
      this.despacho.acao = value.acao
    },

    setDespachoVazio (response) {
      if (response.despacho.status !== 'FINALIZADO') {
        this.despacho = response.despacho
      } else {
        this.despacho = {
          ...response.despacho,
          textoDespacho: '',
          documentos: [],
          processo: response.despacho.processo,
          id: null,
          numeroDaCertidao: null,
          tituloDespacho: { tituloProcesso: null, tituloProcessoDTO: {} }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.flex {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.flex-around {
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.input-text-editor {
  margin-top: 30px;
}
.button-style {
  display: flex;
  flex-direction: row;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/EmissaoExtratoSentenca.vue